import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {ShoppingService} from "../../shared/services/shopping.service";
import {Item} from '../models/item';
import { AlertService } from 'app/shared/services/alert.service';

@Component({
  selector: 'shop-items',
  templateUrl: './shop-items.component.html',
  styleUrls: ['./shop-items.component.css']
})
export class ShopItemsComponent implements OnInit {

  private _items:Item[];
  private _groupItems:Item[];
  private _hasLoadedShop:boolean;

  constructor(
    private shopping:ShoppingService
    ,private alertService: AlertService
    ,private router:Router
    ,private route:ActivatedRoute
  ) { 
    this._hasLoadedShop = false;
  }

  ngOnInit() {
    this.shopping.getAvailableItems().then((items) => {
      this._groupItems = items.filter((i) => i.subItems && i.subItems.length);
      this._items = items.filter((i) => !(i.subItems && i.subItems.length));
      this._hasLoadedShop = true;
    });
  }

  get hasLoadedShop() {
    return this._hasLoadedShop;
  }

  addItemsToCart() {
    let totalitems = this.getItemsForCheckout();
    // return a resolved promise since there's nothing to do here.
    if (!totalitems.length) {
      return Promise.resolve();
    }

    let totalQuantity = totalitems.map(i => i.quantity).reduce((pv, cv) => pv+cv, 0);
    this.addItems(totalitems)
    .then(() => {
      let message = totalQuantity + " items were added to your cart";
      this.alertService.success(message);
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("There was a problem in adding the items you selected to the cart.  Please try again.");
    });
  }

  checkout() {
    let items = this.getItemsForCheckout();
    if (!(items.length || this.hasItems)) {
      this.alertService.error("Please select the number of items you wish to purchase before checking out.");
      return;
    }

    this.addItems(items)
    .then(() => {
      return this.router.navigate(["checkout"], {relativeTo: this.route});
    })
    .catch((error) => {
      console.error(error);
      this.alertService.error("There was a problem in checking out your items, please try again or contact customer support.");
    });
  }

  private addItems(items:Item[]) {
    return Promise.all(items.map(i => this.shopping.addItemToCart(i)))
    .then((results) => {
      items.forEach(i => i.quantity = 0);
    });
  }


  private getItemsForCheckout() {
    let groupItems = this._groupItems.filter(gi => gi.quantity > 0);
    let items = this._items.filter(i => i.quantity > 0);
    let totalItems = groupItems.concat(items);
    return totalItems;
  }

  get hasItems() {
    return this.shopping.hasItems;
  }

  get groupItems() {
    return this._groupItems;
  }

  get items() {
    return this._items;
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/shop-items/shop-items.component.ts